import './tailwind.scss';
import domReady from '@wordpress/dom-ready';
import { __ } from '@wordpress/i18n';
import List from './components/List';
import Details from './components/Details';

domReady( () => {
    window.wp.hooks.addFilter(
        'dokan-dashboard-routes',
        'dokan-vendor-dashboard-vendor-support-list',
        function ( routes ) {
            routes.push( {
                id: 'dokan-vendor-support-list',
                title: __( 'Admin Support', 'dokan' ),
                element: <List />,
                path: 'vendor-support',
                exact: true,
                order: 10,
                parent: '',
            } );

            return routes;
        }
    );

    window.wp.hooks.addFilter(
        'dokan-dashboard-routes',
        'dokan-vendor-dashboard-vendor-support-details',
        function ( routes ) {
            routes.push( {
                id: 'dokan-vendor-support-list',
                title: __( 'Admin Support Details', 'dokan' ),
                element: <Details />,
                path: 'vendor-support/:id',
                exact: true,
                order: 10,
                parent: '',
            } );

            return routes;
        }
    );
} );
